import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import logo from "../../../assets/Guvrix-Logo.png";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { delete_paypal_subscription_api, get_paypal_subscription_api } from "../../../services/NewUI_API";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from "@mui/material";
const theme = localStorage.getItem('brandColor');
const PayPalPortal = () => {
    const [details, setDetails] = useState(null);
    const history = useHistory();
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [isCancelled, setIsCancelled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const planName =
        details?.plan_id === "P-5TT96925AG399652PNE6O2YQ"
            ? "Small Business"
            : details?.plan_id === "P-14360214D4483994TNE6BFBY"
                ? "Multi-Site"
                : details?.plan_id || "";
    const subscriptionId = history?.location?.state?.sub_id || "";
    console.log("history?.location?.state", history?.location?.state);
    const StyledButton1 = styled.button`
  background: ${theme};
  width: 250px;
  border-radius: 30px;
  height: 45px;
  text-align: center;
  color: white;
  font-size: 16px !important;
  font-weight: 500;
  border-color: none;
  border: none;
  margin-top: 25px;
  padding: 5px 10px;
  `;
useEffect(() => {
      if(localStorage.getItem("brandColor") == null || localStorage.getItem("brandColor") == '' ){
        localStorage.setItem("brandColor","#ff8c24");  console.log("vasanth==>", );
    
      }
    }, []);
    const handleDeleteSubscription = () => {
        setShowCancelModal(true);
    };

    const closeModal = () => {
        setShowCancelModal(false);
    };
//paypal sandbox
    // async function generateAccessToken() {
    //     const clientId = "AaeIZWndVeusbANmKL6J23YVkCJwBj-M5rbNVySpoGdh8L2XLatuImGEWM6UkKYrBEWvyDzXNhXiaduN";
    //     const secret = "ECO05ZvSUbxOraJUanXpkcprpqwR8S_z_6a2OCrMLlCXQi2eCBBHYEJ823vvRvASQtpjC3fgP7kCQqoe";

    //     const authString = btoa(`${clientId}:${secret}`);

    //     const response = await fetch("https://api-m.sandbox.paypal.com/v1/oauth2/token", {
    //         method: "POST",
    //         headers: {
    //             "Authorization": `Basic ${authString}`,
    //             "Content-Type": "application/x-www-form-urlencoded",
    //         },
    //         body: "grant_type=client_credentials",
    //     });

    //     const data = await response.json();
    //     const expiryTime = Date.now() + data.expires_in * 1000;
    //     console.log("Generated PayPal Access Token:", data);
    //     localStorage.setItem("paypal_access_token", data.access_token);
    //     localStorage.setItem("paypal_token_expiry", expiryTime);

    //     return data.access_token;
    // }

    //paypal live
    async function generateAccessToken() {
        const clientId = "ASMvK2AgygozS4U8CoTAcbVfWuqYW3dTAhM7ttMu8ZMI8F7lDDveU9LmJuzcmH2d1mQw5LbOx5PZpXmU";
        const secret = "EG_jzLJiBT5KDGJVm7cn1huwnJHTMJTAZRStcOtl7SjnMmzZEWFpAXJAfs9vHNJK9YjtDuJDEW5jpsCK";

        const authString = btoa(`${clientId}:${secret}`);

        const response = await fetch("https://api-m.paypal.com/v1/oauth2/token", {
            method: "POST",
            headers: {
                "Authorization": `Basic ${authString}`,
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: "grant_type=client_credentials",
        });

        const data = await response.json();
        const expiryTime = Date.now() + data.expires_in * 1000;
        console.log("Generated PayPal Access Token:", data);
        localStorage.setItem("paypal_access_token", data.access_token);
        localStorage.setItem("paypal_token_expiry", expiryTime);

        return data.access_token;
    }
    const confirmCancelSubscription = () => {
        delete_paypal_subscription_api({
            subscription_id: subscriptionId
        })
            .then((res2) => {
                console.log("Response:", res2);
                showBlockedDialog("Subscription deleted successfully!");
                setShowCancelModal(false);
                setIsCancelled(true);
            })
            .catch((err) => {
                console.error("Error:", err);
                showBlockedDialog("Failed to delete subscription!");
                setShowCancelModal(false);
            });
    };
    function isPaypalTokenExpired() {
        const token = localStorage.getItem("paypal_access_token");
        const expiry = localStorage.getItem("paypal_token_expiry");

        if (!token || !expiry) return true;

        return Date.now() >= Number(expiry);
    }


    async function getPaypalToken() {
        if (isPaypalTokenExpired()) {
            localStorage.removeItem("paypal_access_token");
            localStorage.removeItem("paypal_token_expiry");
            return await generateAccessToken();
        }

        return localStorage.getItem("paypal_access_token");
    }


    async function fetchPaypalWithRetry(url, options = {}) {
        let token = await getPaypalToken();

        let res = await fetch(url, {
            ...options,
            headers: {
                ...(options.headers || {}),
                Authorization: `Bearer ${token}`,
            },
        });

        let data = await res.json();

        // PayPal rejected token even though time says valid
        if (
            data?.error === "invalid_token" ||
            data?.name === "AUTHORIZATION_ERROR"
        ) {
            // Clear and retry once
            localStorage.removeItem("paypal_access_token");
            localStorage.removeItem("paypal_token_expiry");

            token = await generateAccessToken();

            res = await fetch(url, {
                ...options,
                headers: {
                    ...(options.headers || {}),
                    Authorization: `Bearer ${token}`,
                },
            });

            data = await res.json();
        }

        return data;
    }


    useEffect(() => {
        console.log("subscriptionId", subscriptionId);

        if (!subscriptionId) {
            console.error("No subscription ID provided");
            return;
        }

        // Fetch from database first
        get_paypal_subscription_api({
            subscription_id: subscriptionId
        })
            .then((dbRes) => {
                console.log("Database response:", dbRes.data);

                if (dbRes.data.code === 200) {
                    const dbData = dbRes.data.data;

                    
                    const fetchOrderDetails = async () => {
                        try {
                            const accessToken = await generateAccessToken();
                            //paypal sandbox
                            // const response = await fetch(
                            //     `https://api-m.sandbox.paypal.com/v2/checkout/orders/${subscriptionId}`,
                            //     {
                            //         method: "GET",
                            //         headers: {
                            //             "Content-Type": "application/json",
                            //             "Authorization": `Bearer ${accessToken}`,
                            //         },
                            //     }
                            // );

                            //paypal live
                             const response = await fetch(
                                `https://api-m.paypal.com/v2/checkout/orders/${subscriptionId}`,
                                {
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${accessToken}`,
                                    },
                                }
                            );

                            if (!response.ok) {
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }

                            const paypalData = await response.json();
                            console.log("PayPal Order Details:", paypalData);

                            // Merge both data sources
                            const mergedData = {
                                ...paypalData, 
                                ...dbData,    
                                cancel: dbData.cancel,
                                plan_id: dbData.plan_id,
                                update_min_amount: dbData.update_min_amount,
                                processed: dbData.processed
                            };

                            console.log("Merged data:", mergedData);
                            setDetails(mergedData);

                            if (dbData.cancel == 1 || dbData.cancel == "1") {
                                setIsCancelled(true);
                                console.log("Subscription is cancelled");
                            } else {
                                console.log("Subscription is active");
                            }
                        } catch (err) {
                            console.error("PayPal Order API failed:", err);
                           
                            setDetails(dbData);
                        }
                    };

                    fetchOrderDetails();
                } else {
                    console.error("Failed to get from database:", dbRes.data.message);
                    // Try to get at least PayPal data
                    fetchOrderDetailsStandalone();
                }
            })
            .catch((dbError) => {
                console.error("Database API error:", dbError);
                // Try to get at least PayPal data
                fetchOrderDetailsStandalone();
            });

        // Separate function for when database fails
        const fetchOrderDetailsStandalone = async () => {
            try {
                const accessToken = await generateAccessToken();
                //paypal sandbox
                // const response = await fetch(
                //     `https://api-m.sandbox.paypal.com/v2/checkout/orders/${subscriptionId}`,
                //     {
                //         method: "GET",
                //         headers: {
                //             "Content-Type": "application/json",
                //             "Authorization": `Bearer ${accessToken}`,
                //         },
                //     }
                // );
                //paypal live
                const response = await fetch(
                    `https://api-m.paypal.com/v2/checkout/orders/${subscriptionId}`,
                    
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${accessToken}`,
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    console.log("PayPal data only:", data);
                    setDetails(data);
                }
            } catch (err) {
                console.error("PayPal Order API failed:", err);
            }
        };

    }, [subscriptionId]);

  //paypal sandbox
    // async function generateAccessToken() {
    //     const clientId = "AaeIZWndVeusbANmKL6J23YVkCJwBj-M5rbNVySpoGdh8L2XLatuImGEWM6UkKYrBEWvyDzXNhXiaduN";
    //     const secret = "ECO05ZvSUbxOraJUanXpkcprpqwR8S_z_6a2OCrMLlCXQi2eCBBHYEJ823vvRvASQtpjC3fgP7kCQqoe";

    //     const authString = btoa(`${clientId}:${secret}`);

    //     const response = await fetch("https://api-m.sandbox.paypal.com/v1/oauth2/token", {
    //         method: "POST",
    //         headers: {
    //             "Authorization": `Basic ${authString}`,
    //             "Content-Type": "application/x-www-form-urlencoded",
    //         },
    //         body: "grant_type=client_credentials",
    //     });

    //     const data = await response.json();
    //     console.log("Generated PayPal Access Token:", data);

    //     return data.access_token;
    // }


    //paypal live

    async function generateAccessToken() {
        const clientId = "ASMvK2AgygozS4U8CoTAcbVfWuqYW3dTAhM7ttMu8ZMI8F7lDDveU9LmJuzcmH2d1mQw5LbOx5PZpXmU";
        const secret = "EG_jzLJiBT5KDGJVm7cn1huwnJHTMJTAZRStcOtl7SjnMmzZEWFpAXJAfs9vHNJK9YjtDuJDEW5jpsCK";

        const authString = btoa(`${clientId}:${secret}`);

        const response = await fetch("https://api-m.paypal.com/v1/oauth2/token", {
            method: "POST",
            headers: {
                "Authorization": `Basic ${authString}`,
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: "grant_type=client_credentials",
        });

        const data = await response.json();
        console.log("Generated PayPal Access Token:", data);

        return data.access_token;
    }


    const formatDate = (iso) => {
        const d = new Date(iso);
        let hours = d.getHours();
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;   // Converts 0 → 12
        const day = d.getDate().toString().padStart(2, "0");
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year} ${hours}:${minutes} ${period}`;
    }


    const showBlockedDialog = (message) => {
        console.log("showBlockedDialog called with message:", message);
        setDialogMessage(message);
        setDialogOpen(true);
    };


    const downloadPDF = () => {
        if (!details) return;

        const doc = new jsPDF("p", "mm", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();


        const imgWidth = 20;
        const imgHeight = 20;
        const imgX = (pageWidth - imgWidth) / 2;

        doc.addImage(logo, "PNG", imgX, 10, imgWidth, imgHeight);


        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text("Payment Invoice", pageWidth / 2, 38, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        const planDescription = details.purchase_units?.[0]?.description || "";
        let planName = "One-time Payment";
        let planAmount = "$0.00";

        if (planDescription.includes("Small Business Plan")) {
            planName = "Small Business Plan";
            planAmount = "$660.00";
        } else if (planDescription.includes("Multi-Site Plan")) {
            planName = "Multi-Site Plan";
            planAmount = "$1,800.00";
        } else {
            planName = planDescription || "One-time Payment";
        }


        const amountPaid = details.purchase_units?.[0]?.amount?.value ||
            details.purchase_units?.[0]?.payments?.captures?.[0]?.amount?.value ||
            "0.00";


        const formatDate = (dateString) => {
            if (!dateString) return "N/A";
            try {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            } catch (error) {
                return dateString;
            }
        };


      const statusDisplay =
    details?.status == "COMPLETED" ? "Active" : "InActive";



        const tableData = [
            ["Order ID", details.id],
            ["Status", statusDisplay],
            ["Billing Name", `${details.payer?.name?.given_name || ""} ${details.payer?.name?.surname || ""}`.trim() || "-"],
            ["Billing Email", details.payer?.email_address || "-"],
            ["Plan Name", details.purchase_units?.[0]?.description],
            ["Payment Date", formatDate(details.create_time)],
            ["Plan Amount", planAmount],
            ["Latest Paid Amount", `$ ${amountPaid}`]
        ];

        // Manual table creation (without autoTable plugin)
        let yPos = 50;
        const col1Width = 50; // Smaller for labels
        const col2Width = 140; // Larger for values
        const rowHeight = 10;

        // Table header
        doc.setFillColor(0, 112, 186);
        doc.setTextColor(255, 255, 255);
        doc.rect(10, yPos, col1Width + col2Width, rowHeight, "F");
        doc.text("Field", 10 + col1Width / 2, yPos + 7, { align: "center" });
        doc.text("Value", 10 + col1Width + col2Width / 2, yPos + 7, { align: "center" });
        yPos += rowHeight;

        // Table rows
        doc.setTextColor(0, 0, 0);

        tableData.forEach(([label, value], idx) => {
            // Alternate row colors
            if (idx % 2 === 0) {
                doc.setFillColor(245, 245, 245);
                doc.rect(10, yPos, col1Width + col2Width, rowHeight, "F");
            }

            // Draw cell borders
            doc.rect(10, yPos, col1Width, rowHeight);
            doc.rect(10 + col1Width, yPos, col2Width, rowHeight);

            // Add text
            doc.text(label, 12, yPos + 7);
            doc.text(String(value), 12 + col1Width, yPos + 7);

            yPos += rowHeight;

            // Check if we need a new page
            if (yPos > 280) {
                doc.addPage();
                yPos = 20;
            }
        });

        // Add footer
        doc.setFontSize(10);
        doc.setTextColor(128, 128, 128);
        const currentDate = new Date();
        const footerDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()} ${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}`;

        doc.text(`Generated on: ${footerDate}`, pageWidth / 2, 285, { align: "center" });

        // Save PDF
        doc.save(`Payment_Invoice_${details.id}.pdf`);
    };
    if (!details) return <p></p>;

    return (
        <div className="container">

            <div className="row text-center buttonhide mt-4 mb-4">
                 <StyledButton1
            onClick={() => {
              localStorage.getItem("PlanID") != 1 &&
                localStorage.getItem("token") != null
                ? history.push("/adminfunctionmodal")
                : localStorage.getItem("PlanID") == 1 &&
                  localStorage.getItem("token") != null
                  ? history.push("/dashboard")
                  : history.push("/");
            }}
          >
            Return to Main Menu
          </StyledButton1>
                <div
                    className="col-sm-12 col-md-6 col-lg-4 cust_data_button">
                    <StyledButton1 onClick={() => { history.push("/enroll_ui"); }} >
                        Update Subscription
                    </StyledButton1>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 cust_data_button">
                    {details?.cancel === "1" || isCancelled ? (
                        <div>
                            <StyledButton1
                                disabled
                                style={{
                                    opacity: 0.6,
                                    cursor: 'not-allowed',
                                    marginTop: '20px'
                                }}
                            >
                                Subscription Cancelled
                            </StyledButton1>
                        </div>
                    ) : (
                        <StyledButton1
                            onClick={handleDeleteSubscription}
                            disabled={isLoading}
                        >
                            {isLoading ? "Cancelling..." : "Cancel Subscription"}
                        </StyledButton1>
                    )}
                </div>

                <div

                    className="col-sm-12 col-md-6 col-lg-4 cust_data_button">

                    <StyledButton1
                        onClick={downloadPDF}
                    >
                        Download Invoice PDF
                    </StyledButton1>

                </div>

            </div>


            <h3 className="title">PayPal Subscription Details</h3>
            <div className="d-flex justify-content-center">
                <table className="details-table">
                    <tbody>
                        <tr><td>Subscription ID</td><td>{details.id}</td></tr>
                        <tr>
                            <td>Status</td>
                           <td>
                     {details?.status == "COMPLETED" ? "Active" : "InActive"}
                      </td>

                        </tr>

                        <tr><td>Billing Name</td><td>{details.payer?.name?.given_name} {details.payer?.name?.surname}</td></tr>
                        <tr><td>Billing Email</td><td>{details.payer?.email_address}</td></tr>
                        <tr><td>Plan Name</td><td>{ details.purchase_units?.[0]?.description}</td></tr>
                        <tr><td>Payment Date</td><td>{details.create_time ? new Date(details.create_time).toLocaleDateString('en-GB').replace(/\//g, '-') : "N/A"}</td></tr>
                        <tr>
                            <td>Plan Amount</td>
                            <td>
                                {(() => {
                                    const planDescription = details.purchase_units?.[0]?.description || "";

                                    if (planDescription.includes("Small Business Plan")) {
                                        return "$660.00";
                                    } else if (planDescription.includes("Multi-Site Plan")) {
                                        return "$1800.00";
                                    } else {
                                        // Fallback to showing the actual amount from PayPal
                                        const amount = details.purchase_units?.[0]?.amount?.value ||
                                            details.purchase_units?.[0]?.payments?.captures?.[0]?.amount?.value;
                                        return amount ? `$${amount}` : "$0.00";
                                    }
                                })()}
                            </td>
                        </tr>

                        <tr>
                            <td>Lastest Paid Amount</td>
                            <td>
                                $ {details.purchase_units?.[0]?.amount?.value ||
                                    details.purchase_units?.[0]?.payments?.captures?.[0]?.amount?.value ||
                                    0.00}{" "}

                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            {/* CSS Styles */}
            <style>{`
        .tablecontainer {
          max-width: 900px;
          margin: 25px auto;
          padding: 20px;
          border-radius: 10px;
          background: #ffffff;
          border: 1px solid #cfcfcf;
        }
        .title {
          text-align: center;
          margin-bottom: 20px;
          color: #333;
        }
        .details-table {
          width: 70%;
          border-collapse: collapse;
          font-size: 14px;
          background: #fafafa;
        }
        .details-table td {
          border: 1px solid #ddd;
          padding: 10px;
        }
        .details-table tr:nth-child(even) {
          background: #f0f6ff;
        }
        .details-table td:first-child {
          font-weight: bold;
          width: 40%;
        }
        .btn-download {
          margin-top: 20px;
          width: 100%;
          padding: 12px;
          background: #0070ba;
          border: none;
          color: white;
          font-size: 15px;
          cursor: pointer;
          border-radius: 6px;
        }
        .btn-download:hover {
          background: #055a93;
        }
      `}</style>

            {showCancelModal && (
                <div className="modal-bg">
                    <div className="modal-box">
                        <h3>Cancel Subscription</h3>
                        <p>Are you sure you want to cancel your subscription?</p>

                        <div className="modal-actions">
                            <button onClick={confirmCancelSubscription} className="confirm-btn" style={{ backgroundColor: "#ff8c24" }}>
                                Yes, Cancel
                            </button>
                            <button onClick={closeModal} className="cancel-btn">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Payment Method Restricted</DialogTitle>

                <DialogContent>
                    <p style={{ margin: 0 }}>{dialogMessage}</p>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setDialogOpen(false)}
                        variant="contained"
                        style={{ background: theme }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default PayPalPortal;
